<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目员</div>
          <div class="field">
            <el-input v-model.trim="query.pcreateusername" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">业务员</div>
          <div class="field">
            <el-input v-model.trim="query.psusername" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comfullname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">经办人</div>
          <div class="field">
            <el-input v-model.trim="query.pausername" clearable ></el-input>
          </div>
        </div>
         <div class="searchItem">
          <div class="label">报名开始</div>
          <div class="field" style="width:450px;">
            <el-date-picker
              v-model="query.prsbmbegtime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <!-- <div style="margin:0 10px;">
              至
            </div> -->
            <div class="label" style="width: 160px; margin:0 6px;">报名截止</div>
            <el-date-picker
              v-model="query.prsbmendtime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true" :defaultPage="10" :loading="loading"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick" @pagechange="pagechange"
      >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import dayjs from 'dayjs'
  import utils from '../../assets/js/utils'
  export default {
    name: 'psuConfirmIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',width: 80,addNewRowFlg: false, width: 150},
          { field: 'pausername', fieldtype: 'C', title: '经办人',calculExpr:'',width: 80,addNewRowFlg: false},
          { field: 'pcreateusername', fieldtype: 'C', title: '项目员',calculExpr:'',width: 80,addNewRowFlg: false},
          { field: 'psusername', fieldtype: 'C', title: '业务员',calculExpr:'',width: 80,addNewRowFlg: false},
          { field: 'prsbmbegtime', fieldtype: 'T', title: '报名开始',calculExpr:'',width: 140,addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'prsbmendtime', fieldtype: 'T', title: '报名截止',calculExpr:'',width: 140,addNewRowFlg: false,formatter: ['toDateString', '']},
          { title: '报名下限',showOverflow: true, width: 50,slots: {
              default: 'default',
              default: ({row}) => {
               if (+row.prssupplynums === 0) {
                return [<span>不限</span>]
              } else {
                 return [<span>{ row.prssupplynums}</span>]
              }
              }
          }},
          { field: 'bmnum', fieldtype: 'C', title: '报名数',calculExpr:'',addNewRowFlg: false},
          { title: '待审 ', showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                return [<span style="color: red;">{Math.max(+row.bmwsnum - (+row.expired_count || 0) - (+row.no_upload_count || 0), 0)}</span>]
                // {Math.max(+row.bmwsnum - (+row.expired_count || 0) - (+row.no_upload_count || 0), 0)}
              }
            }
          },
          { field: 'bmtgnum', fieldtype: 'C', title: '审核通过',calculExpr:'',addNewRowFlg: false},
          { title: '缴保证金', showOverflow: true, slots: {
            default: ({ row }) => {
              if (+row.projectbzjamt === 0) {
                return [<span>免</span>]
              } else {
                 return [<span>{ row.bzjnum}</span>]
              }
            }
          }},
          { field: 'prssupplynums', fieldtype: 'C', title: '缴报名费',calculExpr:'',addNewRowFlg: false, slots: {
            default: ({ row }) => {
              if (+row.projectbmamt === 0) {
                return [<span>免</span>]
              } else {
                 return [<span>{ row.bmfnum}</span>]
              }
            }
          }},
          // { field: 'psustatusdesc', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false, width: 100,
          //   slots: {
          //     default: "default",
          //     default: ({ row }) => {
          //       if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
          //         return [<span>无效</span>]
          //       } else {
          //         if (+row.psustatus === 1) {
          //           if (+row.projectisinvite === 1) {
          //             return [<span>待接受</span>]
          //           }else {
          //             return [<span>待审</span>]
          //           }
                    
          //         } else if (+row.psustatus === 2) {
          //           return [<span>驳回</span>]
          //         } else if (+row.psustatus === 3) {
          //           return [<span>通过</span>]
          //         } else if (+row.psustatus === 4) {
          //           return [<span>拒绝</span>]
          //         }
          //       }
          //     }
          //   }
          // },
          // { field: 'psutypeCN', fieldtype: 'C', title: '方式',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'psuAppendMsg', fieldtype: 'C', title: '附件',calculExpr:'',addNewRowFlg: false, width: 80},
          { title: '操作 ', width: 100, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                 // 无效
                // if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
                  return [
                    <vxe-button
                      type="primary"
                      onClick={this.batchConfirm.bind(this, row)}
                    >
                      查看
                    </vxe-button>,
                  ]
                // }
              //   if(+row.psustatus === 1 && dayjs(row.prsbjbegtime).valueOf()>dayjs().valueOf()){
              //     if (+row.projectisinvite === 1) {
              //       return [<vxe-button type='primary' onClick={this.batchConfirm.bind(this, row)}>查看</vxe-button>]
              //     } else {
              //       return [<vxe-button type='primary' onClick={this.batchConfirm.bind(this, row)}>审核</vxe-button>]
              //     }
                  
              //   } else {
              //     return [<vxe-button type='primary' onClick={this.batchConfirm.bind(this, row)}>查看</vxe-button>]
              //   }
              }
            }
          }
        ],
        psu: {},
        projectStatusList: [],
        psustatusList: [],
        psutypeList:[],
        hasappendList:[],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          comtype:this.$store.getters.loginUser.comtype,
          total: 0,
          limit: 10,
          offset: 0,
          psustatus: '1'
        },
        loading: false
      }
    },
    created () {
      this.$on('SHENPI', () => this.batchConfirm())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
      this.getProjectStatusList()
      this.getHasappendList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getPsustatusList () {
        this.psustatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'psustatus'}
        })
      },
      async getPsutypeList () {
        this.psutypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'psutype'}
        })
      },
      async getHasappendList () {
        this.hasappendList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'hasappend'}
        })
      },
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.psu = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        // this.query = {
        //   cosid: this.$store.getters.loginUser.cosid,
        //   userid: this.$store.getters.loginUser.userid,
        //   comid: this.$store.getters.loginUser.comid,
        //   total: 0,
        //   limit: 20,
        //   offset: 0}
        this.list = []
        this.btnLoading = false
        this.psu = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.psu = row.row
      },
      async viewProject(row) {
        this.psu = row.row
        this.$router.push({name: 'psuBmForm', params: {psuid:  row.row.psuid}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async batchConfirm(row) {
        // this.$router.push({name: 'psuBmForm', params: {psuid: row.psuid}})
        this.$router.push({
          name: "BMXXlist",
          params: { projectid: row.projectid, type: 1 },
        });
        // this.$router.push({name: 'psuConfirmForm', params: {projectid: row.projectid}})
      },
      search () {
        this.query.offset = 0
        if(this.query.psuendTime){
          this.query.psuendtime =  dayjs(this.query.psuendTime).add(1, 'day').format('YYYY-MM-D')
        }
        this.getPageList()
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        await this.getPsustatusList()
        await this.getPsutypeList()
        this.loading = true
        this.query.selectField = `pro.prsbmneedconfirm, pro.projectisinvite,pro.prsbmendtime,pro.projectcode,psu.psucontactname,psu.psucontactphone,psu.psubmpayflg,psu.psubzjpayflg,pro.projectptccode,pro.projectname,pro.projecttime,pro.projectid,psu.psubmamt,psu.psubzjamt,psu.psutime,pro.prsbjbegtime,psu.psustatus,psu.psuid,psu.psutype`
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectPurchaseList',
          params: this.query
        })
        this.loading = false
        res.list.forEach(e => {
          e.psutypeCN = +e.psutype === 1 ? '公开':'邀请'
          if(+e.psutype===2){
            if(+e.psustatus === 1){
              e.psustatusdesc = '待接受'
            } else if(+e.psustatus === 3){
              e.psustatusdesc = '己接受'
            } else if(+e.psustatus === 4){
              e.psustatusdesc = '己拒绝'
            }
          }
          if(e.psuAppendCount > 0){
            e.psuAppendMsg = '有'
          } else {
            e.psuAppendMsg = '无'
          }
          if(e.psucontactname && e.psucontactphone){
            e.psuusername = e.psucontactname + " " + e.psucontactphone
          }
          if(Number(e.psubmamt) > 0){
            let bmpayment = '(未付)'
            if(+e.psubmpaytype > 0 && +e.psubmpayflg !== 2){
              bmpayment='(待确认)'
            }
            if(+e.psubmpayflg === 1){
              bmpayment='(已付)'
            } 
            e.psubmamt = utils.comdify(e.psubmamt) + bmpayment
          }
          if(Number(e.psubmamt) === 0){
            e.psubmamt = '免费'
          }
          if(Number(e.psubzjamt) > 0){
              let bzjpayment = '(未付)'
            if (+e.psubzjpaytype > 0 && +e.psubzjpayflg != 2) {
                bzjpayment = '(待确认)'
            } 
            if(+e.psubzjpayflg === 1){
              bzjpayment = '(已付)'
            }
            if(+e.psubzjreturnflg === 1) {
              bzjpayment = '(已退)'
            }
            e.psubzjamt = utils.comdify(e.psubzjamt) + bzjpayment
          }
          if(Number(e.psubzjamt) === 0){
            e.psubzjamt = '免费'
          }
        });
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
